import { useProfileData } from './useProfileData';

export const useBrandData = () => {
  const { data, loading, error, refetch } = useProfileData();

  return {
    brandData: data,
    loading,
    error,
    refetch
  };
};